


















































import Vue from "vue";
import DetectionCard from "../DetectionCard.vue";
import { detectionState } from "../data/state";
import { computed } from "@vue/composition-api";
import { InfoTypeExposure } from "../data/models";
import { SharedState } from "@/common/state";
import { UseModal } from "@/components/root/modal";
import InfoTypeSeveritiesModalVue from "./infotype-severities-modal/InfoTypeSeveritiesModal.vue";
import { ICONS } from "@/common/icons.map";
export default Vue.extend({
  components: {
    DetectionCard,
  },
  setup() {
    const { isLoading, pii_items, regulated } = detectionState;

    const spi = computed(() => {
      return Object.values(regulated.value).reduce((acc, item) => {
        const l0 = SharedState.get_l0_by_code(item.id);
        acc.push({
          id: l0 ? l0.id : "ms",
          high: item["3"] as number,
          medium: item["2"] as number,
          low: item["1"] as number,
        });
        return acc;
      }, [] as InfoTypeExposure[]);
    });

    const spi_drill_down = async (label_id: string) => {
      if (SharedState.restrictions.is_restricted_info(7)) {
        SharedState.restrictions.show_restrictions_modal("info", "Personal");
        return;
      }
      let label_ids: string[] = [];
      let label_name;
      if (label_id == "ms") {
        label_ids = SharedState.PII.ms_labels().map((d) => d.id);
      } else {
        const label = SharedState.getInfoType(label_id)!;
        label_ids = SharedState.PII.spi(label.code).map((d) => d.id);
        label_name = label.labelName;
      }
      await UseModal().show(InfoTypeSeveritiesModalVue, {
        label_name: `Personal - ${label_name}`,
        label_icon: ICONS.L0_ICONS.get(7),
        label_ids,
      });
    };

    const pci_pii_pfi_drill_down = async (label_id: string) => {
      const label = SharedState.getInfoType(label_id)!;
      if (SharedState.restrictions.is_restricted_info(7)) {
        SharedState.restrictions.show_restrictions_modal("info", "Personal");
        return;
      }
      const label_ids = SharedState.PII.L1()
        .find((d) => d.id == label_id)
        ?.nested.map((d) => d.id);
      await UseModal().show(InfoTypeSeveritiesModalVue, {
        label_name: `Personal - ${label.labelName}`,
        label_icon: ICONS.L0_ICONS.get(7),
        label_ids,
      });
    };

    return {
      feature_pii: computed(() =>
        SharedState.FeatureHelper.is_enabled("pii_labeler")
      ),
      isLoading,
      pii_items,
      spi,
      spi_drill_down,
      pci_pii_pfi_drill_down,
    };
  },
});
